import React from "react";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { BsQuestionCircleFill } from "react-icons/bs";

function CustomerNameTooltip() {
  return (
    <OverlayTrigger
      placement='right'
      overlay={
        <Tooltip>
          Uw naam en voornaam <br />
          Bv: Jan Janssen
        </Tooltip>
      }>
      <BsQuestionCircleFill />
    </OverlayTrigger>
  );
}

function CustomerEmailTooltip() {
  return (
    <OverlayTrigger placement='right' overlay={
      <Tooltip>
        Het emailadres waar wij u mogen contacteren voor verdere bestelinformatie. <br />
        Bv: jan.janssen@gmail.com
      </Tooltip>
    }>
      <BsQuestionCircleFill />
    </OverlayTrigger>
  );
}

function CustomerBTWTooltip() {
  return (
    <OverlayTrigger placement='right' overlay={
      <Tooltip>
        Het BTW-nummer van uw bedrijf. <br />
        Bv: BE 0123 456 789
      </Tooltip>
    }>
      <BsQuestionCircleFill />
    </OverlayTrigger>
  );
}

function CustomerStreetTooltip() {
  return <OverlayTrigger placement='right' overlay={
  <Tooltip>
    De straat van het adres. <br />
    Bv: Leuvenseweg
  </Tooltip>
  }>
  <BsQuestionCircleFill />
</OverlayTrigger>
}

function CustomerNumberTooltip() {
  return <OverlayTrigger placement='right' overlay={
  <Tooltip>
    Het huisnummer en/of bus van het adres. <br />
    Bv: 86 (of 86B)
  </Tooltip>
  }>
  <BsQuestionCircleFill />
</OverlayTrigger>
}

function CustomerZipTooltip() {
  return <OverlayTrigger placement='right' overlay={
  <Tooltip>
    De postcode van de gemeente van het adres. <br />
    Bv: 1011
  </Tooltip>
  }>
  <BsQuestionCircleFill />
</OverlayTrigger>
}

function CustomerCityTooltip() {
  return <OverlayTrigger placement='right' overlay={
  <Tooltip>
    De gemeente van het adres. <br />
    Bv: Brussel
  </Tooltip>
  }>
  <BsQuestionCircleFill />
</OverlayTrigger>
}

export { CustomerNameTooltip, CustomerEmailTooltip, CustomerBTWTooltip, CustomerStreetTooltip, CustomerNumberTooltip, CustomerZipTooltip, CustomerCityTooltip };
